import {useTranslation} from "react-i18next";
import useCustomTranslation from "core/customTranslation";
import Form from "react-bootstrap/Form";
import {useEffect, useRef, useState} from "react";
import ProgressBar from "react-bootstrap/ProgressBar";
import {SwalAlertClass} from "core/swalClass";

// -
import TableWarnings from "./TableWarnings";
import apiAxi from "ApiCaller";
import WsConnector from "core/wsConnector";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import {useNavigate} from "react-router-dom";

const stepTabsStatus = {
    //Status disabled tabs
    select: false,
    validation: true,
    confirmation: true,
    result: true,
};

const checksStatus = {
    // checkbox status
    loading: false,
    headers: false,
    lines: false,
    devices: false,
    save: false,
};

const translations = {
    es: {
        "loading-file": "Archivo cargado",
        "checking-headers": "Comprobando cabeceras",
        "checking-devices": "Comprobando dispositivos",
        "saving-data": "Guardando datos",
    },
    en: {
        "loading-file": "File loaded",
        "checking-headers": "Checking headers",
        "checking-devices": "Checking devices",
        "saving-data": "Saving data",
    },
};

const TabSelectFile = (props) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const navigate = useNavigate();
    const checksBoxStatus = useRef({...checksStatus});
    const [statusChecks, setStatusChecks] = useState({...checksStatus});
    const [error, setError] = useState("");
    const [percent, setPercent] = useState(0);
    const wsConn = new WsConnector();

    wsConn.message = (e) => {
        let data = JSON.parse(e.data);
        if (data.end) {
            checksBoxStatus.current[data.end] = true;
            setStatusChecks(checksBoxStatus.current);
        }
        setPercent(parseInt(data.percent));
        if (data.error) {
            setError(data.error);
            props.warnings.current.push({
                line: 0,
                active: "Error",
                message: data.error,
            });
            props.setWarningsShow([...props.warnings.current]);
        }
        if (data.warning) {
            props.warnings.current.push(data.warning);
            props.setWarningsShow([...props.warnings.current]);
        }
        if (data.ended) {
            let tabs = {...props.statusTabs};
            tabs.validation = false;
            tabs.confirmation = false;
            tabs.result = true;
            props.setStatusTabs(tabs);
            props.setKeyTab("confirmation");
            props.setDataVerify(data.result);

            wsConn.close();
        }
    };
    wsConn.opened = () => {
        console.log("[TabVerifyData].opened()", new Date());
        console.log(wsConn.ws.readyState);
    };

    const activeWebsocket = () => {
        console.log("[TabVerifyData].activeWebsocket()", new Date());
        wsConn.setUrl(`/ws/inventory/plugin/import/${props.roomID.current}/`);
        wsConn.connect();
    };

    const changeSendFile = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        let selectFile = e.detail;
        props.warnings.current = [];
        props.setWarningsShow([]);
        // make a POST request to the File Upload API with the FormData object and Rapid API headers
        props.setStatusTabs(stepTabsStatus);
        checksBoxStatus.current = {...checksStatus};
        setStatusChecks(checksBoxStatus.current);
        apiAxi
            .post(`/api/plugins/inventory/import/${props.token}/`, selectFile, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((resp) => {
                if (resp.data.status) {
                    props.roomID.current = resp.data.room;
                    activeWebsocket();
                    let tabs = {...stepTabsStatus};
                    tabs.validation = false;
                    tabs.confirmation = true;
                    tabs.result = true;
                    props.setStatusTabs(tabs);
                    props.setKeyTab("validation");
                }
            })
            .catch((error) => {
                console.error(error);
                Alert.error(_Tf("errors.server-error")).then(() => {
                    navigate("/adminstration/plugins/");
                });
            });
    };

    useEffect(() => {
        subscribeEvent("notifyinventorychangesendfile", changeSendFile);
        checksBoxStatus.current = {...checksStatus};
        setStatusChecks(checksBoxStatus.current);
        return () => {
            unsubscribeEvent("notifyinventorychangesendfile", changeSendFile);
            wsConn.close();
        };
    }, []);

    return (
        <div className="row">
            <div className="col-md-10 col-12 m-auto">
                <div className="row">
                    <div className="col-12">
                        <p>{_Tf("inventory.title-tab-verify-data")}</p>
                        <p>{_Tf("inventory.title-tab-verify-description")}</p>
                    </div>
                    <div className="col-md-6 col-12">
                        <Form.Check
                            disabled
                            type="checkbox"
                            className="mb-2"
                            label={_TC("loading-file")}
                            id="check-loading"
                            checked={statusChecks.loading}
                        />
                        <Form.Check
                            disabled
                            type="checkbox"
                            className="mb-2"
                            label={_TC("checking-headers")}
                            id="check-headers"
                            checked={statusChecks.headers}
                        />
                        <Form.Check
                            disabled
                            type="checkbox"
                            className="mb-2"
                            label={_TC("checking-devices")}
                            id="check-devices"
                            checked={statusChecks.devices}
                        />
                        <Form.Check
                            disabled
                            type="checkbox"
                            className="mb-2"
                            label={_TC("saving-data")}
                            id="check-save"
                            checked={statusChecks.save}
                        />
                    </div>
                    {error ? (
                        <div className="col-md-6 col-12 text-danger">
                            <h5>{_Tf("labels.error")}:</h5>
                            <p>{error}</p>
                            <p className="text-danger">{_Tf("inventory.error")}</p>
                        </div>
                    ) : (
                        <></>
                    )}

                    <div className="col-12 mt-5">
                        <h5>{_Tf("labels.progress-bar")}</h5>
                        <ProgressBar
                            now={percent}
                            label={`${percent}%`}
                            variant="success"
                            striped
                        />
                    </div>
                    <div className="col-12 text-end mt-5">
                        <button
                            className="btn btn-primary"
                            onClick={props.handleBackSelectFile}>
                            {_Tf("labels.back")}
                        </button>
                    </div>
                    {props.warningsShow.length ? (
                        <TableWarnings items={props.warningsShow} />
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TabSelectFile;
